import React from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import { Button } from 'reactstrap';
import { Link } from 'react-router-dom';
import { Scrollbars } from 'react-custom-scrollbars';
import Loading from '../../system/components/Loading';
import ReactTable from 'react-table';
import checkboxHOC from 'react-table/lib/hoc/selectTable';
import Aux from '../../system/containers/Aux';
import Toolbar from './components/Toolbar';
import PageHeader from '../../system/components/PageHeader';
import { WrappedTable, filterString } from '../../system/containers/Table';

import { actionCreators } from '../../store/payments';

const CheckboxTable = checkboxHOC(ReactTable);
const columns = [
  {
    accessor: 'first_name',
    Header: 'First Name',
    filterMethod: filterString,
    Cell: props => (
      <a href={'/payment/edit/' + props.original.id}>{props.value}</a>
    ),
  },
  {
    accessor: 'last_name',
    Header: 'Last Name',
    filterMethod: filterString,
    Cell: props => (
      <a href={'/payment/edit/' + props.original.id}>{props.value}</a>
    ),
  },
  {
    accessor: 'price',
    Header: 'Price',
    filterMethod: filterString,
    Cell: props => (
      <a href={'/payment/edit/' + props.original.id}>£{props.value}</a>
    ),
  },
  {
    accessor: 'booking_number',
    Header: 'Booking Reference',
    filterable: false,
  },
  {
    accessor: null,
    Header: null,
    filterable: false,
    Cell: props => (
      <div className="text-center">
        <Link to={'/payment/edit/' + props.original.id}>
          <Button outline size="sm">
            Edit
          </Button>
        </Link>
      </div>
    ),
  },
];

class List extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      data: [],
    };
  }

  componentWillMount() {
    this.props.dispatch(actionCreators.fetchAll());
  }

  remove() {
    let items = this.props.selected;
    if (items.length === 0) {
      return alert('You have not selected any entries');
    }
    const result = window.confirm(
      'Are you sure you want to remove these entries?'
    );
    if (result) {
      this.props.dispatch(actionCreators.delete(items));
    }
  }

  render() {
    const { data, permissions, checkboxProps, loading } = this.props;
    if (loading) {
      return <Loading />;
    }
    return (
      <Aux>
        <PageHeader title="Create Payment" />
        <Toolbar
          permissions={permissions}
          createLink={'/payment/create'}
          total={data.length}
          handleDelete={() => this.remove()}
        />
        <Scrollbars
          style={{ width: '100%', height: '100%', paddingBottom: '60px' }}
        >
          {console.log(data, 'asffs')}
          <CheckboxTable
            ref={r => (this.checkboxTable = r)}
            data={data}
            keyField="id"
            showPaginationBottom
            filterable
            columns={columns}
            loading={data.loading}
            defaultPageSize={20}
            style={{
              height: '100vh',
            }}
            className="-striped -highlight"
            {...checkboxProps}
          />
        </Scrollbars>
      </Aux>
    );
  }
}

function mapStateToProps(store) {
  return {
    permissions: store.auth.permissions,
    data: store.payments.list,
    loading: store.payments.loading,
  };
}

const WrapTable = WrappedTable(List);

export default connect(mapStateToProps)(WrapTable);



// WEBPACK FOOTER //
// ./src/containers/Payments/List.jsx